/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Package - Workstation (@accedo/xdk-device-workstation) 4.1.1
* 
*******************************************************************************/
const ID="workstation";export default"workstation";